import {
  BFF_ROUTES,
  EmailVerificationSendResponseSchema,
  EmailVerificationVerifyResponseSchema,
  type EmailVerificationSendRequest,
  type EmailVerificationSendResponse,
  type EmailVerificationVerifyRequest,
  type EmailVerificationVerifyResponse,
} from '@rheora/enrollment-contract';

import { bffPost } from './bff-client';

/**
 * Typed fetchers for the E-SF05 email OTP. Thin: POST the request, validate the
 * response against the shared contract schema, return. Pages never import these
 * directly — the `email-verification.queries` hooks wrap them. Same shape as
 * `credit.fetchers.ts`.
 *
 * ── THE CODE GOES UP, NEVER COMES BACK ─────────────────────────────────────
 * `/send` returns only WHEN the challenge expires and WHEN a resend is allowed —
 * never the code itself (the BFF's boot-time response guard forbids a `code` field
 * on any response, and `EmailVerificationSendResponseSchema` has none). Validating
 * against that schema here means a drifted response that "helpfully" echoed a code
 * would fail `safeParse` at this boundary rather than reach the React tree.
 *
 * `/verify` answers `200` in EVERY outcome (verified/incorrect/expired/locked) —
 * those are answers to a well-formed question, not protocol errors — so the caller
 * branches on `status`, not on a thrown error. A genuine failure (401 no session,
 * 400 no challenge, 429 throttled, 501 SMTP unconfigured) still throws a `BffError`.
 */

export async function postEmailVerificationSend(
  request: EmailVerificationSendRequest,
): Promise<EmailVerificationSendResponse> {
  return bffPost(BFF_ROUTES.emailVerificationSend, request, EmailVerificationSendResponseSchema);
}

export async function postEmailVerificationVerify(
  request: EmailVerificationVerifyRequest,
): Promise<EmailVerificationVerifyResponse> {
  return bffPost(
    BFF_ROUTES.emailVerificationVerify,
    request,
    EmailVerificationVerifyResponseSchema,
  );
}
